import { type Common } from './common.js';
import { type DetailedCoverage } from './models/realTimeEligibility/availity.js';
import { type RealTimeEligibilityResults } from './models/realTimeEligibility/patient.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async checkRealTimeEligibility(
    patientInsuranceInformationId: string,
    npi: string
  ): Promise<DetailedCoverage> {
    const url = this.common.constructPath('/real-time-eligibility');
    return await this.common.postJSON(url, {
      patientInsuranceInformationId,
      npi,
    });
  }

  async checkPatientRealTimeEligibilityByFormSetId(
    patientInsuranceInformationId: string,
    previsitFormSetId: string
  ): Promise<RealTimeEligibilityResults> {
    const url = this.common.constructPath('/patient-previsit/real-time-eligibility');
    return await this.common.postJSON(url, {
      patientInsuranceInformationId,
      previsitFormSetId,
    });
  }
}
